import { Notyf } from 'notyf';

// Shared singleton so multiple toasts stack in one container instead of each
// call mounting its own overlapping container. Turbo Drive replaces <body> on
// navigation, discarding Notyf's injected container while this reference
// survives, so rebuild whenever that container is no longer in the document.
let notyf;

function notyfInstance() {
  if (!notyf || !document.querySelector(".notyf")) {
    notyf = new Notyf();
  }

  return notyf;
}

// Opt-in dedupe (see the `dedupe` option below). Only the server-flash path
// (toast_controller) enables it, so direct flash() callers keep their existing
// behavior and can intentionally show identical toasts back to back.
let lastKey = null;
let lastFlashedAt = 0;
const DEDUPE_WINDOW_MS = 1000;

// Test helper: resets the dedupe state so examples don't leak into each other.
export function resetFlashDedupe() {
  lastKey = null;
  lastFlashedAt = 0;
}

// When `dedupe` is true, suppress a repeat of the same message+type fired within
// DEDUPE_WINDOW_MS in one page lifetime. Turbo can render the server flash region
// twice in a single navigation — the integrations page nests its content in a
// frame with data-turbo-action="advance", so a save that redirects to the same
// URL is promoted to a page refresh and connects the toast controller (calling
// flash()) twice for the same message. A hard reload resets this state.
export default function flash(message, flashType, { dedupe = false } = {}) {
  if (dedupe) {
    const key = `${flashType}:${message}`;
    const now = Date.now();

    if (key === lastKey && now - lastFlashedAt < DEDUPE_WINDOW_MS) {
      return;
    }

    lastKey = key;
    lastFlashedAt = now;
  }

  const instance = notyfInstance();
  if (flashType == "success") {
    instance.success({message: message, duration: 5000, dismissible: true, background: "#0E700E", ripple: false});
  } else {
    instance.error({message: message, duration: 5000, dismissible: true, background: "#B10E1C", ripple: false});
  }
}
